import { styled } from '../../Styles/stitches.config'

export const StyledDivider = styled('div', {
    bgc: '$neutral400',

    variants: {
        orientation: {
            horizontal: {
                h: 1,
                w: '100%',
            },
            vertical: {
                h: '100%',
                w: 1,
            },
        },
    },

    defaultVariants: {
        orientation: 'vertical',
    },
})
